module.exports = __webpack_public_path__ + "img/rightArrow.aeb41b6f.svg";